/**
 * Configuración de la vista de lista "Existencias" (stock por local).
 * La tabla se muestra junto a contentBefore (selector de local, KPIs, filtros).
 */

import { ProductIcon } from '@/lib/polaris-icons';
import type { ListViewConfig } from '@/types/listView.types';
import { ROUTES } from '@/config/routes.config';

export interface ExistenciasListItem {
  id: string;
  name: string;
  image_url: string;
  category: string;
  stock: number;
  /** Slug para URL de inventario (ej. cheesecake-de-fresa) */
  slug: string;
}

export type NavigateFn = (path: string) => void;

export function getExistenciasListConfig(toUrl: NavigateFn): ListViewConfig<ExistenciasListItem> {
  return {
    title: 'Existencias',
    titleIcon: ProductIcon,
    onBack: () => toUrl(ROUTES.PRODUCTS),
    backAccessibilityLabel: 'Volver a Productos',
    resourceName: {
      singular: 'producto',
      plural: 'productos',
    },
    columns: [
      {
        key: 'image_url',
        title: 'Producto',
        type: 'thumbnailWithText',
        imageKey: 'image_url',
        textKey: 'name',
        altKey: 'name',
        fontWeight: 'medium',
      },
      {
        key: 'category',
        title: 'Categoría',
        type: 'badge',
        format: (_, item) => (item.category as string) || '—',
      },
      {
        key: 'stock',
        title: 'Stock Actual',
        type: 'number',
        format: (value) => `${value} und`,
        toneFromValue: (value) =>
          value <= 5 ? 'critical' : value <= 10 ? 'caution' : undefined,
      },
      {
        key: 'actions',
        title: 'Editar Stock',
        type: 'actions',
        editLabel: 'Editar',
        delete: false,
      },
    ],
    emptyState: {
      heading: 'No hay productos registrados',
      description: 'Crea productos para gestionar su inventario.',
      image: 'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
      action: {
        content: 'Ir a Productos',
        onAction: () => toUrl(ROUTES.PRODUCTS),
      },
    },
    bulkActions: [
      { content: 'Exportar datos', actionKey: 'export' },
      { content: 'Establecer stock a 0', actionKey: 'setZero' },
    ],
    idKey: 'id',
  };
}
